import { useNavigate } from "react-router-dom";
import logo from '../assets/img/logo.png'

const Logo = ({ isMobile }) => {
    const navigate = useNavigate();
     const handleHome = () => {
        navigate('/')
    }

    return (
        <img
            src={logo}
            alt="logo"
            style={{ cursor: 'pointer', width: isMobile ? '120px' : '180px' }}
            onClick={handleHome}
        /> 
    );
};

export default Logo;